var _rect, _path, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M470 120 L960 70 L960 930 L470 880",
    fill: "none",
    stroke: "#0057B8",
    strokeWidth: 18
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 390,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 165,
    fontWeight: 900,
    textAnchor: "middle",
    fill: "#ffffff"
  }, "\n    HOME\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 555,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 165,
    fontWeight: 900,
    textAnchor: "middle",
    fill: "#ffffff"
  }, "\n    SERVICE\n  ")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 680,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 90,
    fontWeight: 700,
    letterSpacing: 4,
    textAnchor: "middle",
    fill: "#dedede"
  }, "\n    EXPERTS\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHse);
export default __webpack_public_path__ + "static/media/hse.de5bf8e2aa6d4d2e67fc373a20259f1b.svg";
export { ForwardRef as ReactComponent };